/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

export const useSingleInfoLine = () => {
  const singleInfoLine = (title: string, value: string | undefined) => (
    <div css={css({ display: "flex", gap: "4px" })}>
      <Typography component="p" variant="body3Regular">
        {title}:
      </Typography>

      <Typography component="p" variant="body3Regular" sx={{ fontWeight: 700 }}>
        {value}
      </Typography>
    </div>
  );

  return { singleInfoLine };
};
